import { render, staticRenderFns } from "./DossierActivityDomainPanel.DynamicView.vue?vue&type=template&id=4580afce&scoped=true"
import script from "./DossierActivityDomainPanel.DynamicView.vue?vue&type=script&lang=ts"
export * from "./DossierActivityDomainPanel.DynamicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4580afce",
  null
  
)

export default component.exports